// extracted by mini-css-extract-plugin
export default {"container":"complectationPaid-module__container--n4xyv","summContainer":"complectationPaid-module__summContainer--EsaJh"};